<template>
  <VApp>
    <VContent>
      <VContainer
        fluid
        fill-height
      >
        <VLayout
          align-center
          justify-center
        >
          <VFlex
            md4
            sm8
            xs12
          >
            <ResetPasswordRequestCard />
          </VFlex>
        </VLayout>
      </VContainer>
    </VContent>
  </VApp>
</template>

<script>
import ResetPasswordRequestCard from '@/components/ResetPasswordRequestCard'
export default {
  name: 'ResetPasswordPage',
  components: {
    ResetPasswordRequestCard
  }
}
</script>

<style scoped>

</style>
